export default "__VITE_ASSET__D6pkX2az__"